import { Component, input, model } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { DirectusTranslationPipe } from "../../../../../../common/pipes/directus-translation.pipe";
import { ItemsProductCategories } from "../../../../../api/packbo/models/items-product-categories";

@Component({
    selector: "packbo-subcategory-sidebar",
    templateUrl: "./subcategory-sidebar.template.html",
    imports: [DirectusTranslationPipe, TranslocoPipe]
})
export class SubcategorySidebarComponent {
    public readonly subcategories = input.required<ItemsProductCategories[]>();
    public readonly selectedSubcategoryId = model<number | null>(null);

    public getSuppliersBySubcategory(subcategoryId: number | undefined): void {
        if (!subcategoryId) {
            return;
        }

        this.selectedSubcategoryId.set(subcategoryId);
    }

    public resetSelectedSubcategoryId(): void {
        this.selectedSubcategoryId.set(null);
    }
}
